export class HeroSearchModel {
    categoryId: string;
    key: string;
    constructor() {
        this.categoryId = '';
        this.key = '';
    }
}
